import React from 'react';
import { Link, Navigate, NavLink } from "react-router-dom"
import { Database } from '../../server/database';
import { Server } from '../../server/server';
import LoginModal from '../modals/LoginModal';
import { getPortraitImage } from '../util/util';
import GameCard from '../elements/GameCard';
import './GamePage.css'
import './TournamentPage.css'
import AlertModal from '../modals/AlertModal';
import { AppConfig } from '../AppConfig';

interface TournamentPageState {
  play: boolean;
  login: boolean;
  loading: boolean;
  leaderboard: any[];
  rows: any[];
  openLogin: boolean;
  alert: string;
}

class TournamentPage extends React.Component<{}, TournamentPageState> {
  protected userName: string;
  protected portrait: string;
  protected bestScore: number;

  constructor(props:{}) {
    super(props);

    this.bestScore = 0;

    this.state = {
      play: false,
      login: false,
      loading: true,
      leaderboard: [],
      rows: [],
      openLogin: false,
      alert: ''
    };

    this.onPlay = this.onPlay.bind(this);
    this.refresh = this.refresh.bind(this);
    this.onFriendUpdated = this.onFriendUpdated.bind(this);
    this.onCloseLogin = this.onCloseLogin.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.refresh();
    Server.network.setPresence('site');
    Server.user.addEventListener('friend-updated', this.onFriendUpdated);
  }

  componentWillUnmount() {
    Server.user.removeEventListener('friend-updated', this.onFriendUpdated);
  }

  getGameId() {
    return window.location.pathname.substring(9);
  }

  getPresence(userId: string) {
    if(!Server.account.isLoggedIn())
      return false;

    let isFriend = Server.user.isFriend(userId);
    if (isFriend) {
      let friend = Server.user.getFriend(userId);
      return friend.presence.online;
    }

    return false;
  }

  onFriendUpdated() {
    this.forceUpdate();
  }

  async refresh() {
    this.setState({loading: true});

    let gameId = this.getGameId();
    let tourneyId = gameId + '-tournament';

    if (Server.account.isLoggedIn()) {
      let scoreResponse = await Server.games.getScore(tourneyId);
      if(scoreResponse.success) {
        this.userName  = Server.user.getName();
        this.portrait  = getPortraitImage(Server.user.getProfile());
        this.bestScore = scoreResponse.score;
      }
    }

    let response = await Server.games.getLeaderboard(tourneyId);
    if(!response.success)
      return;

    let userIds = [];
    for(let i = 0; i < response.leaderboard.length; i++)
      userIds.push(response.leaderboard[i].id);

    await Server.public.loadProfiles(userIds);

    this.setState({
      loading: false,
      leaderboard: response.leaderboard
    });
  }

  processLeaderboard(leaderboard: any[]) {
    let rows = [];
    // console.log("--> leaderboard", leaderboard)

    let fakeNames = ['Wile', 'Daffy', 'Elmer', 'Sylvester', 'Marvin', 'Porky', 'Bugs', 'Sam', 'Foghorn' , 'Tweety']
    let top10 = false;

    for(let i = 0; i < 10; i++) {
      let entry = null;
      if(i < leaderboard.length)
        entry = leaderboard[i];
        
      let profile  = entry ? Server.public.getProfile(entry.id) : null;
      let id       = profile ? profile.id : '';
      let name     = profile ? profile.name : fakeNames[i];
      let slug     = profile ? profile.slug : '';
      let portrait = getPortraitImage(profile);
      let score    = entry ? entry.score.toString() : '100';

      // for online green circle
      let online = false;
      if (id)
        online = this.getPresence(id);

      // for highlight yourself
      let hl = false;
      if (id == Server.user.getId()) {
        hl    = true;
        top10 = true;
      }

      if(score != '') 
        score = score.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      if(slug == '') {
        rows.push(
          <div className='leaderboard-portrait-container' key={(i+1)*1000}>
            <img className="game-page-leaderboard-portrait" src={portrait} />
            {online &&
              <div className="leaderboard-green-circle" />
            }
          </div>
        );
        rows.push(
          <div key={(i+1)*100000} className="game-page-leaderboard-name">
            {name}
          </div>
        );
        rows.push(<div key={(i+1)*10000000} className="game-page-leaderboard-score" style={{textAlign: 'right'}}>{score}</div>);
      }
      else {
        rows.push(
          <NavLink className='leaderboard-portrait-container' key={(i+1)*1000} to={"/profile/" + slug}>
            <img className="game-page-leaderboard-portrait link" src={portrait} />
            {online &&
              <div className="leaderboard-green-circle" />
            }
          </NavLink>
        );
        rows.push(
          <NavLink key={(i+1)*100000} className={`game-page-leaderboard-name link highlight ${hl ? 'show' : ''}`} to={"/profile/" + slug}>
            <div >{name}</div>
          </NavLink>
        );
        rows.push(<div key={(i+1)*10000000} className={`game-page-leaderboard-score highlight ${hl ? 'show' : ''}`} style={{textAlign: 'right'}}>{score}</div>);
      }
    }

    if (!top10 && this.bestScore != 0 && Server.account.isLoggedIn()) {
      let score = this.bestScore.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      rows.push(<img key={52} className="game-page-leaderboard-portrait link highlight show" src={this.portrait} />);
      rows.push(<div key={53} className="game-page-leaderboard-name link highlight show">{this.userName}</div>);
      rows.push(<div key={54} className="game-page-leaderboard-score link highlight show" style={{textAlign: 'right'}}>{score}</div>);
    }

    return rows;
  }

  saveRecentlyPlayed(gameId: string) {
    let played = [gameId];
    let list   = localStorage.getItem('recently-played');

    if (list) {
      played = JSON.parse(list);

      let index = played.indexOf(gameId);
      if (index !== -1)
        played.splice(index, 1);

      // if (played.length == 4)
      //   played.pop();

      played.unshift(gameId);
    }

    localStorage.setItem('recently-played', JSON.stringify(played));
  }

  onPlay() {
    if(!Server.account.isLoggedIn()) {
      this.setState({openLogin: true});
      return;
    }

    let gameId = this.getGameId();
    let costToPlay = Database.getTournamentCost(gameId);

    if(costToPlay > Server.user.getCoinCount()) {
      this.setState({alert: 'You do not have enough coins to play!'});
      return;
    }

    Server.network.setPresence(gameId);
    this.saveRecentlyPlayed(gameId);

    this.setState({play: true});
  }

  onCloseLogin() {
    this.setState({ openLogin: false });
  }

  render() {
    let gameId = this.getGameId();
    let game = Database.getGame(gameId);

    if(!game)
      return (<Navigate to="/games" replace />);

    if(this.state.play)
      return (<Navigate to={'/play/' + gameId + '?contest'} />);

    let rows = this.processLeaderboard(this.state.leaderboard);
    let content = this.state.loading ? <div style={{height: '365px'}}>Loading...</div> : rows;

    let costToPlay = 10;
    if(gameId == 'matcha-blitz') costToPlay = 10;
    if(gameId == 'solitaire') costToPlay = 25;
    if(gameId == 'whacka') costToPlay = 8;

    return (
      <div>
        <div className="game-page">
          <div className="game-page-container">
            <div className="game-page-button-panel">
              <div>Contest Rules</div>
              <ul style={{margin: '0px', padding: '0px 0px 0px 20px', fontSize: '0.9em', color: '#ffffffa0'}}>
                <li>Ends March 31st at 12pm EST</li>
                <li>Top 10 players win a pack</li>
                <li>Coins earned every game</li>
                <li>Better chance at loot drops</li>
              </ul>
            </div>

            <div className="game-page-button-panel" style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
              <div>Inventory</div>
              <div style={{display: 'flex', alignItems: 'center', columnGap: '5px'}}>
                  {Server.user.getCoinCount()} <img style={{width: '26px'}} src={'/assets/' + AppConfig.coin.id + '.png'}></img>
                </div>
            </div>

            <div className="game-page-button-panel">
              <button className="tournament-page-play-button" onClick={this.onPlay}>
                <div>Play Game</div>
                <div style={{display: 'flex', alignItems: 'center', columnGap: '5px'}}>
                  {costToPlay} <img style={{width: '26px'}} src={'/assets/' + AppConfig.coin.id + '.png'}></img>
                </div>
              </button>
              <Link style={{color: 'white', textDecoration: 'none'}} to={'/help/' + gameId}>
                <button style={{width: '100%'}}>
                  Help
                </button>
              </Link>
            </div>

            <div className="game-page-leaderboard-panel">
              <div className="game-page-leaderboard-header">Leaderboard</div>
              <div className="game-page-leaderboard">
                {content}
              </div>
              <div className="game-page-leaderboard-footer"></div>
            </div>

          </div>
        </div>
        <LoginModal open={this.state.openLogin} onClose={this.onCloseLogin} />
        <AlertModal message={this.state.alert} button="OK" onClose={()=>this.setState({alert: ''})}/>
      </div>
    );
  }
}

export default TournamentPage;
